import { InjectionToken } from "@angular/core";


export const APP_TITLE = new InjectionToken<string>('AppTitle');
export const PRODUCTION = new InjectionToken<string>('Production');
export const DOMAIN = new InjectionToken<string>('Domain');
export const BASE_URL = new InjectionToken<string>('BaseUrl');
export const STABLE_URL = new InjectionToken<string>('StableUrl');
export const LOCALE = new InjectionToken<string>('Locale');
export const CURRENCY_CODE = new InjectionToken<string>('CurrencyCode');
export const DEFAULT_ROLE_ID = new InjectionToken<string>('DefaultRoleId');
export const UI = new InjectionToken<string>('Ui');
export const ORG_ID = new InjectionToken<string>('OrgId');
export const GTM_ID = new InjectionToken<string>('GtmId');
export const ENABLE_ANALYTICS = new InjectionToken<string>('EnableAnalytics');
export const ENABLE_DEV_TOOLS_REDUX = new InjectionToken<string>('EnableDevToolsRedux');
export const ENABLE_COMPONENT_VIEW = new InjectionToken<string>('EnableComponentView');
export const HOME_DIRECTORY = new InjectionToken<string>('HomeDirectory');
export const STABLE_API_KEY = new InjectionToken<string>('stableAPIKey');
export const PUSHER = new InjectionToken<string>('pusher');
export const ENVIRONMENT = new InjectionToken<string>('environment');
export const EPROTECT = new InjectionToken<string>('eProtect');
export const SMARTLOOK = new InjectionToken<string>('smartlook');
